import React from 'react';
import { Link } from 'react-router-dom';
import servicesData from '../../../data/services-data';
import ctaImage from '../../../assets/img/page/cta-1.jpg';
import image1 from '../../../assets/img/portfolio/portfolio-7.jpg';
import image2 from '../../../assets/img/portfolio/portfolio-8.jpg';
// import image2 from '../../../assets/img/portfolio/portfolio-8.jpg';

const ServicesConstruction = () => {
    return (
        <>
            <div className="services__details section-padding">
                <div className="container">
                    <div className="row">
                        {/* <div className="col-lg-4 columns_sticky">
                            <div className="all__sidebar">                        
                                <div className="all__sidebar-item">
                                    <h4>Our Solutions</h4>
                                    <div className="all__sidebar-item-category">
                                        <ul>
                                            {servicesData.slice(0, 5).map((data, id) => (
                                                <li key={id}><Link to={`/services/${data.id}`}>{data.title}<i className="flaticon-right-up"></i></Link></li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                                <div className="all__sidebar-item-help mb-25" style={{backgroundImage: `url(${ctaImage})`}}>
                                    <h3>Ready for Your Next Construction?</h3>
                                    <Link className="build_button mt-20" to="/contact-us">Get an Advice<i className="flaticon-right-up"></i></Link>
                                </div>
                                <div className="all__sidebar-item">
                                    <h4>Download</h4>
                                    <div className="all__sidebar-item-download">
                                        <ul>
                                            <li><Link to="#">Company Details<span className="fal fa-arrow-to-bottom"></span></Link></li>
                                            <li><Link to="#">Our Brochures<span className="fal fa-arrow-to-bottom"></span></Link></li>
                                        </ul>                            
                                    </div>
                                </div>
                            </div>  
                        </div> */}
                        <div className="col-lg-12">
                            <div className="services__details-area">
                                {/* <img src={singleData.image} alt="image" /> */}
                                {/* <h3 className="mt-25 mb-20">{servicesData.title}</h3> */}
                                <div className="services__details-area">
                                <h2 className="mb-20">Introduction</h2>
                                <p className="mb-20">
                                    Construction services go beyond laying bricks and mortar—they are about transforming spaces into lasting, functional, and beautiful structures. Whether it’s a home, office, or commercial facility, a well-managed construction process ensures quality, safety, and efficiency. With today’s booming real estate market and rising construction costs, choosing the right construction partner has never been more important.
                                </p>

                                <div className="row mt-40 mb-40">
                                    <div className="col-sm-6 sm-mb-25">
                                        <img className="img_full" src={image1} alt="image" />
                                    </div>
                                    <div className="col-sm-6">
                                        <img className="img_full" src={image2} alt="image" />
                                    </div>
                                </div>
                                <h3 className="mb-20">The Process of Constructing a New Building</h3>
                                <h4 className="mb-20">1. Planning &amp; Design</h4>
                                <p className="mb-20">
                                    Every project begins with careful planning. Clients share their requirements, preferences, and vision. The construction company then develops detailed drawings, cost estimates, and schedules to align with expectations.
                                </p>
                                <h4 className="mb-20">2. Budgeting &amp; Cost Control</h4>
                                <p className="mb-20">
                                    A realistic budget is established before breaking ground. This ensures financial clarity and helps prevent cost overruns. Professional contractors also factor in material, labor, and compliance costs upfront.
                                </p>
                                <h4 className="mb-20">3. Construction &amp; Project Management</h4>
                                <p className="mb-20">
                                    From excavation to finishing, the construction company manages all aspects:
                                </p>
                                <ul className="mb-20">
                                    <li>Structural Work</li>
                                    <li>Electrical &amp; Plumbing</li>
                                    <li>Masonry &amp; Finishing</li>
                                    <li>Interior &amp; Exterior Detailing</li>
                                </ul>
                                <p className="mb-20">
                                    Project managers monitor quality, safety, and timelines, ensuring seamless execution.
                                </p>
                                <h4 className="mb-20">4. Handover &amp; Aftercare</h4>
                                <p className="mb-20">
                                    Once completed, the building is handed over to the client with all inspections cleared. Many firms also provide aftercare, maintenance, and warranty services for added peace of mind.
                                </p>

                                <h3 className="mb-20">Benefits of Professional Construction Services</h3>
                                <h4 className="mb-20">Reliable Funding &amp; Cost Security</h4>
                                <p className="mb-20">
                                    Unlike poorly managed projects that often exceed budget, professional construction ensures better cost control. Contracts clearly define payment schedules and responsibilities, minimizing risks for the client.
                                </p>
                                <h4 className="mb-20">Reduced Risks &amp; Overheads</h4>
                                <p className="mb-20">
                                    A skilled construction firm manages procurement, workforce, and compliance, saving clients from hidden costs and delays.
                                </p>
                                <h4 className="mb-20">Time Efficiency</h4>
                                <p className="mb-20">
                                    Well-structured construction projects are completed faster, thanks to systematic planning and overlapping phases where possible. Meeting deadlines is a priority, ensuring clients can use their new property sooner.
                                </p>
                                <h4 className="mb-20">Collaborative Approach</h4>
                                <p className="mb-20">
                                    A good construction company values client input at every stage. From choosing finishes to reviewing progress, clients and builders work as a team to achieve the desired outcome.
                                </p>
                                <h4 className="mb-20">Quality Assurance</h4>
                                <p className="mb-20">
                                    Working with an experienced contractor guarantees durable construction. With strict supervision, certified materials, and skilled workers, clients can expect consistent, high-quality results.
                                </p>
                                <h4 className="mb-20">Trust &amp; Transparency</h4>
                                <p className="mb-20">
                                    Reputable construction firms maintain transparency in costing, timelines, and progress. This builds trust and ensures a stress-free client experience.
                                </p>

                                <h3 className="mb-20">Why Choose Our Construction Services?</h3>
                                <ul className="mb-20">
                                    <li>Expertise in Residential, Commercial &amp; Industrial Projects</li>
                                    <li>Modern &amp; Sustainable Building Practices</li>
                                    <li>Transparent Costing &amp; Timelines</li>
                                    <li>Strong Track Record of Successful Projects</li>
                                </ul>
                                <p className="mb-20">
                                    Whether you’re building a new home, a commercial space, or renovating an existing property, our construction services ensure strength, quality, and peace of mind—from the ground up.
                                </p>
                                <p className="mb-20">
                                    <strong>Contact us today to discuss your next construction project.</strong>
                                </p>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>          
        </>
    );
};

export default ServicesConstruction;